// ============================================================
// CALCULADOR DE FRETE (Borem) — handler via delegação
// Markup: snippets/custom-shipping-calculator.liquid
// Mantido fora do theme.js para sobreviver às atualizações do tema.
// ============================================================
(function() {
  if (window.boremShippingCalculatorLoaded) return;
  window.boremShippingCalculatorLoaded = true;

  var UF_MAP = {
    AC:'Acre', AL:'Alagoas', AM:'Amazonas', AP:'Amapá', BA:'Bahia',
    CE:'Ceará', DF:'Distrito Federal', ES:'Espírito Santo', GO:'Goiás',
    MA:'Maranhão', MG:'Minas Gerais', MS:'Mato Grosso do Sul', MT:'Mato Grosso',
    PA:'Pará', PB:'Paraíba', PE:'Pernambuco', PI:'Piauí', PR:'Paraná',
    RJ:'Rio de Janeiro', RN:'Rio Grande do Norte', RO:'Rondônia', RR:'Roraima',
    RS:'Rio Grande do Sul', SC:'Santa Catarina', SE:'Sergipe', SP:'São Paulo',
    TO:'Tocantins'
  };

  function calcConvertToReal(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function calcRemoveProduct(variantId) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: 0 })
    }).catch(function() {});
  }

  function calcSetLoading(btn, loading) {
    var loader = btn.parentElement ? btn.parentElement.querySelector('.custom-shipping-calc-loader') : null;
    btn.style.display = loading ? 'none' : '';
    if (loader) loader.style.display = loading ? 'inline-flex' : 'none';
  }

  // tempVariantId: variante adicionada só para o cálculo; é removida no final.
  function calcShipping(btn, zipCode, tempVariantId) {
    var parent = btn.closest('.custom-shipping-calculator');
    var cleanup = function() {
      calcSetLoading(btn, false);
      if (tempVariantId) calcRemoveProduct(tempVariantId);
    };

    calcSetLoading(btn, true);

    fetch('https://viacep.com.br/ws/' + zipCode + '/json/')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.erro) {
          alert('CEP não encontrado.');
          cleanup();
          return;
        }
        var province = UF_MAP[data.uf ? data.uf.toUpperCase() : ''] || '';
        if (!province) {
          alert('Estado não identificado.');
          cleanup();
          return;
        }

        fetch('/cart/shipping_rates.json?shipping_address[zip]=' + zipCode +
              '&shipping_address[country]=Brazil' +
              '&shipping_address[province]=' + encodeURIComponent(province))
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var rates = data.shipping_rates || [];
            var ratesContainer = parent.querySelector('.shipping-rates');
            ratesContainer.innerHTML = '<p><strong>' +
              (rates.length > 1 ? 'Existem ' + rates.length + ' tipos de fretes disponíveis.' :
               rates.length === 1 ? 'Existe 1 tipo de frete disponível.' :
               'Nenhuma opção de frete encontrada.') +
              '</strong></p>';
            rates.forEach(function(rate) {
              var days = rate.delivery_days && rate.delivery_days[0];
              var printDays = days > 0 ? ' - ' + days + (days === 1 ? ' dia útil' : ' dias úteis') : '';
              var printPrice = Number(rate.price) > 0 ? calcConvertToReal(rate.price) : 'Grátis';
              var li = document.createElement('li');
              li.innerHTML = '<strong>' + escapeHtml(rate.name) + '</strong> - ' + printPrice + printDays;
              ratesContainer.appendChild(li);
            });
            cleanup();
          })
          .catch(function() {
            alert('Erro ao calcular frete. Tente novamente.');
            cleanup();
          });
      })
      .catch(function() {
        alert('CEP inválido. Verifique e tente novamente.');
        cleanup();
      });
  }

  // Máscara de CEP sem biblioteca externa
  document.addEventListener('input', function(e) {
    if (!e.target.classList || !e.target.classList.contains('custom_zip_code')) return;
    var v = e.target.value.replace(/\D/g, '').substring(0, 8);
    e.target.value = v.length > 5 ? v.substring(0, 5) + '-' + v.substring(5) : v;
  }, true);

  // Enter no campo de CEP dispara o cálculo
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('custom_zip_code')) return;
    e.preventDefault();
    var parent = e.target.closest('.custom-shipping-calculator');
    var btn = parent && parent.querySelector('.custom_shipping_button');
    if (btn) btn.click();
  });

  // Delegação de clique
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.custom_shipping_button');
    if (!btn) return;

    var parent = btn.closest('.custom-shipping-calculator');
    if (!parent) return;

    var zipCode = ((parent.querySelector('.custom_zip_code') || {}).value || '').replace(/\D/g, '');

    if (zipCode.length !== 8) {
      alert('Digite um CEP válido (8 dígitos).');
      return;
    }

    if (parent.getAttribute('data-template') !== 'product') {
      calcShipping(btn, zipCode, null);
      return;
    }

    // Página de produto: usa o formulário da mesma seção do calculador
    var scope = btn.closest('.shopify-section') || document;
    var form = scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
    var variantInput = form ? form.querySelector('[name="id"]') : null;
    var variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      alert('Variante não identificada.');
      return;
    }

    calcSetLoading(btn, true);

    // Se a variante já está no carrinho, calcula direto (sem adicionar/remover,
    // para não apagar o item que o cliente já tinha).
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var inCart = (cart.items || []).some(function(item) { return String(item.variant_id) === String(variantId); });
        if (inCart) {
          calcShipping(btn, zipCode, null);
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function(r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function() { calcShipping(btn, zipCode, variantId); });
      })
      .catch(function() {
        calcSetLoading(btn, false);
        alert('Não foi possível calcular o frete. Tente novamente.');
      });
  });
})();
